import { Type } from "@sinclair/typebox";
const position = Type.Tuple([
    Type.Number({ minimum: -180, maximum: 180 }),
    Type.Number({ minimum: -90, maximum: 90 })
]);
const polygon = Type.Array(Type.Array(position, { minItems: 4 }), { minItems: 1 });
const referenceGeometry = Type.Union([
    Type.Object({ type: Type.Literal("Polygon"), coordinates: polygon }),
    Type.Object({
        type: Type.Literal("MultiPolygon"),
        coordinates: Type.Array(polygon, { minItems: 1 })
    })
]);
const text = Type.String({ minLength: 1 });
const positiveMeasurements = Type.Record(Type.String(), Type.Number({ exclusiveMinimum: 0 }));
/** Reported dimensions remain observations: never extrusion heights or certified quantities. */
export const oralRoofObservationSchema = Type.Object({
    id: text,
    body: text,
    candidateAssociation: Type.Object({ label: text, status: text }),
    dimensionsM: positiveMeasurements,
    heightsM: positiveMeasurements,
    heightDatum: Type.Optional(text),
    heightSemantics: Type.Optional(text),
    dimensionEdgeMeaning: Type.Optional(text),
    overhangDistribution: Type.Optional(text),
    roofShape: Type.Null(),
    source: text,
    recordedAt: text,
    method: Type.Literal("oral_recollection"),
    approximate: Type.Literal(true),
    surveyed: Type.Literal(false),
    quantityApproved: Type.Literal(false),
    geometryExportAvailable: Type.Literal(false)
}, { additionalProperties: false });
/** Context bodies have their own reference IDs; none becomes a cadastral/structure identity. */
export const siteReferenceSetSchema = Type.Object({
    version: Type.Literal("operational-reference-set/v1"),
    buildingId: text,
    siteKey: Type.Union([Type.Literal("emilia"), Type.Literal("canovi")]),
    contextOnly: Type.Literal(true),
    bodies: Type.Array(Type.Object({
        id: text,
        label: text,
        geometry: referenceGeometry,
        source: Type.Object({
            name: text,
            id: text,
            artifactPath: text,
            artifactSha256: Type.String({ pattern: "^[a-f0-9]{64}$" })
        }, { additionalProperties: false }),
        reviewStatus: text,
        quantityApproved: Type.Literal(false)
    }, { additionalProperties: false }), { minItems: 1, maxItems: 10 }),
    observations: Type.Array(oralRoofObservationSchema, { maxItems: 20 }),
    limitations: Type.Array(text, { minItems: 1 })
}, { additionalProperties: false });
//# sourceMappingURL=site-reference.js.map